import { BuildingOffice2Icon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline'
import Footer from "./Footer";
import Header from "./Header";
import {db} from "../../firebase/firebase";
import {useState} from "react";
import {Button, Input, Textarea} from "@headlessui/react";

const Contact = () => {

    const [fName, setFName] = useState("");
    const [lName, setLName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        const collectionRef = db.collection('Messages');

        const parsedFormData = {
            fName: fName,
            lName: lName,
            email: email,
            phone: phone,
            message: message,
            responded: false,
        };

        try {
            // Add the new document to Firestore
            await collectionRef.add(parsedFormData);

            console.log('Item added successfully!');
            // await onUpdate();

            setMessage("");
            setFName("");
            setLName("");
            setPhone("");
            setEmail("");

        } catch (error) {
            console.error('Error adding/item: ', error);
        }
    };

    return (
        <div className={`h-screen`}>
            <Header/>

            <div className="relative isolate bg-white">

                {/*Contact Section*/}
                <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2">
                    <div className="relative px-6 pb-20 pt-24 sm:pt-32 lg:static lg:px-8 lg:py-48">
                        <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
                            <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
                                <svg
                                    aria-hidden="true"
                                    className="absolute inset-0 size-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                                >
                                    <defs>
                                        <pattern
                                            x="100%"
                                            y={-1}
                                            id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                                            width={200}
                                            height={200}
                                            patternUnits="userSpaceOnUse"
                                        >
                                            <path d="M130 200V.5M.5 .5H200" fill="none"/>
                                        </pattern>
                                    </defs>
                                    <rect fill="white" width="100%" height="100%" strokeWidth={0}/>
                                    <svg x="100%" y={-1} className="overflow-visible fill-gray-50">
                                        <path d="M-470.5 0h201v201h-201Z" strokeWidth={0}/>
                                    </svg>
                                    <rect fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)" width="100%" height="100%"
                                          strokeWidth={0}/>
                                </svg>
                            </div>
                            <h2 className="animate-slideInLeft text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                                Get in touch
                            </h2>
                            <p className="animate-slideInLeft mt-6 text-lg/8 text-gray-600">
                                Make a difference in the lives of high risk youth by sending in-kind and cash donations
                                to Bridge 127, Inc. You may also contact us to learn more about the services offered by
                                our nonprofit organization in supporting the high risk youth. Thank you for visiting our
                                website and we look forward to hearing from you!
                            </p>
                            <dl className="mt-10 animate-slideInBottom space-y-4 text-base/7 text-gray-600">
                                <div className="flex gap-x-4">
                                    <dt className="flex-none">
                                        <span className="sr-only">Address</span>
                                        <BuildingOffice2Icon aria-hidden="true" className="h-7 w-6 text-gray-400"/>
                                    </dt>
                                    <dd>
                                        19 North Centre Street
                                        <br/>
                                        Pottsville, PA 17901
                                    </dd>
                                </div>
                                <div className="flex gap-x-4">
                                    <dt className="flex-none">
                                        <span className="sr-only">Telephone</span>
                                        <PhoneIcon aria-hidden="true" className="h-7 w-6 text-gray-400"/>
                                    </dt>
                                    <dd>
                                        <a href="tel:+1 (570)-573-3613" className="hover:text-gray-900">
                                            +1 (570)-573-3613
                                        </a>
                                    </dd>
                                </div>
                                <div className="flex gap-x-4">
                                    <dt className="flex-none">
                                        <span className="sr-only">Email</span>
                                        <EnvelopeIcon aria-hidden="true" className="h-7 w-6 text-gray-400"/>
                                    </dt>
                                    <dd>
                                        <a href="mailto:bridge127@icloud.com" className="hover:text-gray-900">
                                            bridge127@icloud.com
                                        </a>
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                    <form action="#" method="POST" className="animate-slideInRight px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48">
                        <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
                            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                                <div>
                                    <label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
                                        First name
                                    </label>
                                    <div className="mt-2.5">
                                        <Input
                                            id="first-name"
                                            name="first-name"
                                            type="text"
                                            value={fName}
                                            onChange={(e) => setFName(e.target.value)}
                                            autoComplete="given-name"
                                            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
                                        Last name
                                    </label>
                                    <div className="mt-2.5">
                                        <Input
                                            id="last-name"
                                            name="last-name"
                                            type="text"
                                            value={lName}
                                            onChange={(e) => setLName(e.target.value)}
                                            autoComplete="family-name"
                                            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
                                        Email
                                    </label>
                                    <div className="mt-2.5">
                                        <Input
                                            id="email"
                                            name="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            autoComplete="email"
                                            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="phone-number"
                                           className="block text-sm/6 font-semibold text-gray-900">
                                        Phone number
                                    </label>
                                    <div className="mt-2.5">
                                        <Input
                                            id="phone-number"
                                            name="phone-number"
                                            type="tel"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            autoComplete="tel"
                                            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                        />
                                    </div>
                                </div>
                                <div className="sm:col-span-2">
                                    <label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
                                        Message
                                    </label>
                                    <div className="mt-2.5">
                                      <Textarea
                                          id="message"
                                          name="message"
                                          value={message}
                                          onChange={(e) => setMessage(e.target.value)}
                                          rows={4}
                                          className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                                          defaultValue={''}
                                      />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-8 flex justify-end">
                                <Button
                                    onClick={handleSubmit}
                                    type="submit"
                                    className="rounded-md bg-blue-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Send message
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>

            <Footer/>
        </div>
    )
};

export default Contact;
